import {Column, HeaderProps} from 'react-table'
import {ILink} from './_modal'
import SelectionHeader from '../../../utils/components/table-content/SelectionHeader'
import {ListViewContext} from '../../../utils/contextProvider/ListViewProvider'
import {SelectionCell} from '../../../utils/components/table-content/SelectionCell'
import {PropsWithChildren} from 'react'
import {CustomHeader} from '../../../utils/components/table-content/CustomHeader'
import ActionCell from '../../../utils/components/table-content/ActionCell'

const linkListColumn = (handleSelect: (id: number) => void): ReadonlyArray<Column<ILink>> => [
  {
    Header: (props) => <SelectionHeader tableProps={props} context={ListViewContext} />,
    id: 'selection',
    Cell: ({...props}) => (
      <SelectionCell id={props.data[props.row.index].link_id} context={ListViewContext} />
    ),
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ILink>>) => (
      <CustomHeader tableProps={props} title='Link name' className='min-w-100px' />
    ),
    id: 'link_name',
    accessor: 'link_name',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ILink>>) => (
      <CustomHeader tableProps={props} title='url' className='min-w-100px' />
    ),
    id: 'link_value',
    accessor: 'link_value',
  },
  {
    Header: (props: PropsWithChildren<HeaderProps<ILink>>) => (
      <CustomHeader tableProps={props} title='Action' className='min-w-100px text-end' />
    ),
    id: 'action',
    Cell: ({...props}) => (
      <ActionCell id={props.data[props.row.index].link_id} selectItem={handleSelect} />
    ),
  },
]

export default linkListColumn
